import type { PopoverOrigin } from '@mui/material';

/**
 * The persona-card Menu's anchor/transform origins, computed from
 * `collapsed` — never copied verbatim from the old top-right `TopBar`
 * values. Those were tuned for a top-right trigger with room below it;
 * this trigger sits at the bottom of the screen, so the menu must open
 * **upward**. Extracted as its own pure function so both states are
 * unit-testable without fighting MUI Popper's DOM internals.
 *
 *  - Expanded: the card is a wide, left-aligned row — anchor/transform
 *    from the left edge.
 *  - Collapsed: the trigger is a small centered icon in the 64px rail —
 *    the horizontal origin re-centers so the menu doesn't clip off the
 *    narrow rail's edge.
 */
export const getPersonaMenuOrigins = (
  collapsed: boolean,
): { readonly anchorOrigin: PopoverOrigin; readonly transformOrigin: PopoverOrigin } => ({
  anchorOrigin: { horizontal: collapsed ? 'center' : 'left', vertical: 'top' },
  transformOrigin: { horizontal: collapsed ? 'center' : 'left', vertical: 'bottom' },
});
